import React from 'react';

export default function LoadingSpinner({ size = 28, color = '#9333ea', text = null }) {
  return (
    <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', padding: '60px 0', gap: 12 }}>
      <div
        className="spinner"
        style={{
          width: size,
          height: size,
          border: '3px solid #e5e7eb',
          borderTopColor: color,
          borderRadius: '50%',
        }}
      />
      {text && <span style={{ fontSize: 14, color: '#9ca3af' }}>{text}</span>}
    </div>
  );
}
